import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import MarqueeSection from "./components/MarqueeSection";
import TrustBanner from "./components/TrustBanner";
import FeaturesGrid from "./components/FeaturesGrid";
import PricingSection from "./components/PricingSection";
import ComparisonTable from "./components/ComparisonTable";
import EnterpriseForm from "./components/EnterpriseForm";
import FAQSection from "./components/FAQSection";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import ImpressumPage from "./components/ImpressumPage";
import DatenschutzPage from "./components/DatenschutzPage";

function HomePage() {
  return (
    <>
      <Hero />
      <MarqueeSection />
      <TrustBanner />
      <FeaturesGrid />
      <PricingSection />
      <ComparisonTable />
      <EnterpriseForm />
      <FAQSection />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050505] text-white font-body antialiased grain-overlay overflow-x-hidden" data-testid="app-root">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
